import React from 'react';
// reducer
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import {AgChartsReact} from 'ag-charts-react';
import {Header, Segment} from 'semantic-ui-react';
interface IOwnProps {
    noOfReqVsActuality: any;
    marketVsRequirement: any;
    statusVsRequirement: any;
    marketVsTypeFamilies: any;
    t: reactI18Next.TranslationFunction;
}

export const OverviewWorld = (props: IOwnProps) => {
    const {marketVsRequirement, marketVsTypeFamilies, noOfReqVsActuality, statusVsRequirement, t} = props;
    return (
        <div className='char-container'>
            <Segment className='chart-segment-left'>
                <Header>
                    {t("KUMA_ALL_REQUIREMENTS")}
                </Header>
                {noOfReqVsActuality && <AgChartsReact options={noOfReqVsActuality} />}
            </Segment>
            <div className='chart-segment-right'>
                <div className='chart-segment-right-top'>
                    <Segment className='chart-segment'>
                        <Header>
                            {t("KUMA_REQ_PER_MARKET")}
                        </Header>
                        {marketVsRequirement && <AgChartsReact options={marketVsRequirement} />}
                    </Segment>
                    <Segment className='chart-segment'>
                        <Header>
                            {t("KUMA_REQ_PER_TYPEFAMILY")}
                        </Header>
                        {marketVsTypeFamilies && <AgChartsReact options={marketVsTypeFamilies} />}
                    </Segment>
                </div>
                <div className='chart-segment-right-bottom'>
                    <Segment className='chart-segment'>
                        {statusVsRequirement && <AgChartsReact options={statusVsRequirement} />}
                    </Segment>
                </div>

            </div>

        </div>

    );
};



// WEBPACK FOOTER //
// ./src/components/kuma/OverviewWorld.tsx